import type { TournamentRegistration, Transaction, User } from '@repo/database/src/types';
import type { TournamentRegistrationDefaultArgs, TournamentRegistrationGetPayload } from '@repo/database/src/types';
import { RebuyAddonType } from '@repo/database/src/types';
import { IsOptional, IsString } from 'class-validator';

export interface RegisterPlayerDto {
  tournamentId: string;
  userId: string;
  ticketId?: string | null; // optional, for redeeming a ticket
  entries?: number;
}

export interface UpdateRegistrationDto {
  isEliminated?: boolean;
  finalPosition?: number;
  prizeAwarded?: number;
}

export interface RebuyAddonDto {
  tournamentId: string;
  userId: string;
  type: RebuyAddonType;
  amount: number;
  chipStackAdded: number;
  reentriesCount?: number;
}

// Define the validator for tournament registration with user included
export const tournamentRegistrationWithUser = {
  include: {
    user: true,
  },
} satisfies TournamentRegistrationDefaultArgs;

// Create a type from the validator
export type TournamentRegistrationWithUser = TournamentRegistrationGetPayload<typeof tournamentRegistrationWithUser>;

// Simplified version for when we don't need the full user object
export type TournamentRegistrationWithUserSimple = TournamentRegistration & {
  user: Pick<User, 'id' | 'firstName' | 'lastName' | 'alias' | 'email'>;
};

export enum TournamentRegistrationState {
  NOT_REGISTERED = 'NOT_REGISTERED',
  PENDING = 'PENDING',
  REGISTERED = 'REGISTERED',
  ELIMINATED = 'ELIMINATED',
}

export type TournamentRegistrationWithTournament = TournamentRegistrationGetPayload<{
  include: {
    tournament: true;
  };
}>;

export interface TournamentRegistrationStatusDto {
  id?: string;
  userId: string;
  registeredAt?: Date;
  state: TournamentRegistrationState;
  registrationId?: string;
  pendingTransactionId?: string;
  status: TournamentRegistrationState;
  prizeAwarded?: number;
  reentriesCount?: number;
  tournamentId: string;
  ticketId?: string;
  eliminationAt?: Date;
  finalPosition?: number;
}

export class RegisterPlayerTransactionReqDto {
  @IsString()
  userOpHash: string;
}

export type RegisterPlayerTransactionRespDto = Transaction;

export class FailRegistrationReqDto {
  @IsString()
  reason: string;
}

export type UnregisterPlayerRespDto = Transaction;

export class UnregisterPlayerReqDto {
  @IsString()
  @IsOptional()
  ticketId?: string; // optional, for redeeming a ticket
}
